import React from "react";
import { useSelector } from "react-redux";
import { getModals, getModalsLoading } from "../../selectors/commonSelectors";

// General
import MediaPickerModal from "../MediaPicker/modals/MediaPickerModal";

// Posts
import PreviewPostModal from "../Posts/modals/PreviewPostModal";
import ImportIgPostsModal from "../ImportIgPostsModal/index.js";

// Sked Url
import SkedUrlModal from "../Posts/modals/SkedUrlModal";

// External Collab
import ExternalCollabModal from "../Posts/modals/ExternalCollabModal";
import ExternalPermissionModal from "../../external-review/components/ExternalPermissionModal";

// Media Library
import NewCollectionModal from "../MediaLibrary/modals/NewCollectionModal";
import ConfirmModal from "../../ui/modals/ConfirmModal";
import AssetDetailsSheet from "../MediaLibrary/modals/AssetDetailsSheet";
import BulkAssetTagsModal from "../MediaLibrary/modals/BulkAssetTagsModal";
import BulkMoveAssetsModal from "../MediaLibrary/modals/BulkMoveAssetsModal";
import AddToCollectionModal from "../MediaLibrary/modals/AddToCollectionModal";
import ViewHashtagFeedItemModal from "../MediaLibrary/modals/ViewHashtagFeedItemModal";
import DuplicateAssetsModal from "../MediaLibrary/modals/DuplicateAssetsModal";

// Insights
import { AddInsightsReportsModal } from "../../features/plans-modal/dialogs/insights-reports";

import { Modals } from "../../libs/modals";

const MODAL_COMPONENTS = {
  ADD_COLLECTION: NewCollectionModal,
  CONFIRM_MODAL: ConfirmModal,
  EDIT_COLLECTION_ASSET: AssetDetailsSheet,
  BULK_ASSET_TAGS: BulkAssetTagsModal,
  BULK_MOVE_ASSETS: BulkMoveAssetsModal,
  DUPLICATE_ASSETS: DuplicateAssetsModal,
  ADD_TO_COLLECTION: AddToCollectionModal,
  VIEW_HASHTAG_FEED_ITEM: ViewHashtagFeedItemModal,
  PREVIEW_POST: PreviewPostModal,
  SKED_URL: SkedUrlModal,
  EXTERNAL_COLLAB: ExternalCollabModal,
  EXTERNAL_PERMISSION: ExternalPermissionModal,
  ADD_INSIGHTS_REPORTS: AddInsightsReportsModal,
  MEDIA_PICKER: MediaPickerModal,
  IMPORT_IG_POSTS: ImportIgPostsModal,
};

const ModalRoot = () => {
  const modals = useSelector(getModals) ?? [];
  const loading = useSelector(getModalsLoading);

  return (
    <>
      {modals.map((modalInstance) => {
        const { modalType, modalProps } = modalInstance;
        const SpecificModal = MODAL_COMPONENTS[modalType];
        if (SpecificModal) {
          return (
            <SpecificModal key={modalType} {...modalProps} loading={loading} />
          );
        }
      })}

      <Modals />
    </>
  );
};

export default ModalRoot;
